import { roles } from '@nxsys/store/constants';
import { hasTenantFeed } from '@nxsys/store/slices/app/roleOf';
import jwtAxios from '../axios';
import { endPoints } from '../endpoints';

export const getNotificationsApi = async (
  role: string,
  userId?: string,
  subcontractorId?: string,
  agencyId?: string,
  queryParams?: Record<string, any>,
) => {
  let url = '';
  if (hasTenantFeed(role)) {
    url = endPoints.notification.admin;
  } else if (role === roles.employer) {
    url = `${endPoints.notification.employer}/${userId}`;
  } else if (role === roles.employee) {
    url = `${endPoints.notification.subcontractor}/${subcontractorId}`;
  } else if (role === roles.agency) {
    // NX-5237: an agency's notifications are stored against the agency id
    // (subType 'agency'), not the user — the admin feed never returns them.
    url = `${endPoints.notification.agency}/${agencyId}`;
  }
  // NX-5877: a role with no feed reads nothing. It used to read the tenant's
  // admin feed.
  if (!url) return {};
  const response = await jwtAxios.get(url, { params: queryParams });
  return response.data;
};

export const markAllReadApi = async (
  role: string,
  userId?: string,
  subcontractorId?: string,
  agencyId?: string,
) => {
  let url = '';
  if (hasTenantFeed(role)) {
    url = endPoints.notification.readAllInAdmin;
  } else if (role === roles.employer) {
    url = `${endPoints.notification.readAllInEmployer}/${userId}`;
  } else if (role === roles.employee) {
    url = `${endPoints.notification.readAllInSub}/${subcontractorId}`;
  } else if (role === roles.agency) {
    url = `${endPoints.notification.readAllInAgency}/${agencyId}`;
  }
  if (!url) return {};
  const response = await jwtAxios.put(url);
  return response.data;
};

export const markReadByIdApi = async (id: string) => {
  const response = await jwtAxios.put(
    `${endPoints.notification.readByID}/${id}`,
  );
  return response.data;
};
